import "../../assets/styles/product-view.css";
import React from "react";
import { FormattedMessage } from "react-intl";

const Team = () => {
  return (
    <div className="team">
      <div
        data-content-type="html"
        data-appearance="default"
        data-element="main"
        data-decoded="true"
      >
        <div className="team-content">
          <h3 className="title">
            <FormattedMessage id="Talk to our experts" />
          </h3>
          <span>
            <FormattedMessage id="Experts description" />
          </span>
          <a className="phone" href="tel:+493023590710">
            +49 30 23590710
          </a>
        </div>
      </div>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n    .catalog-product-view .product-information .box-left .team > div{\n        margin-top: 0;\n        margin-bottom: 50px;\n        width: 100%;\n        display: flex;\n    }\n    @media screen and (max-width: 1199px){\n        .catalog-product-view .product-information .box-left .team > div{\n            width: 100%;\n            display: grid;\n            margin-bottom: 20px;\n        }\n    }\n\n",
        }}
      />
    </div>
  );
};
export default Team;
